import { render, staticRenderFns } from "./documentary.vue?vue&type=template&id=5d588e11&scoped=true"
import script from "./documentary.vue?vue&type=script&lang=js"
export * from "./documentary.vue?vue&type=script&lang=js"
import style0 from "./documentary.vue?vue&type=style&index=0&id=5d588e11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d588e11",
  null
  
)

export default component.exports